import script from "./Landing.vue?vue&type=script&setup=true&lang=js"
export * from "./Landing.vue?vue&type=script&setup=true&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=3b4177fb&scoped=true&lang=css"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b4177fb"]])

export default __exports__